import React, { useState } from "react";
import { Button, Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";

const ProfileForm = (props) => {

    const API = new PrivateApi();
    const user = props.user;

    const [anrede, setAnrede] = useState(user.x_anrede !== 'False'? user.x_anrede : '');
    const [title, setTitle] = useState(user.title[1] !== 'False'? user.title.split("'")[1]:"");
    const [firmenbuch_nr, setFirmenbuch_nr] = useState(user.x_firmenbuch_nr !== 'False'? user.x_firmenbuch_nr: '');
    const [vat, setVat] = useState(user.vat !== 'False'? user.vat:'');
    const [name, setName] = useState(user.name !== 'False'? user.name:'');
    const [title_postfix, setTitle_postfix] = useState(user.x_title_postfix !== 'False'? user.x_title_postfix : '');
    const [birthdate, setBirthdate] = useState(user.x_birthdate);
    const [email, setEmail] = useState(user.x_qr_login !== 'False'? user.x_qr_login:'');
    const [mobile, setMobile] = useState(user.mobile !== 'False'? user.mobile:'');
    const [street, setStreet] = useState(user.street !== 'False'? user.street:'');
    const [zip, setZip] = useState(user.zip !== 'False'? user.zip:'');
    const [city, setCity] = useState(user.city !== 'False'? user.city:'');
    const [account_owner, setAccount_owner] = useState(user.x_account_owner !== 'False'? user.x_account_owner:'');
    const [account_bic, setAccount_bic] = useState(user.x_account_bic === 'False'? '' : user.x_account_bic !== undefined? user.x_account_bic:'');
    const [account_iban, setAccount_iban] = useState(user.x_account_iban !== 'False'? user.x_account_iban: '');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const submitHandler = (event) => {
        setIsLoading(true);
        setErrorMsg("");
        event.preventDefault();
        let data = {};
        if (user.x_anrede === 'False') user.x_anrede ='';
        if (user.title === 'False') user.title = '';
        if (user.vat === 'False') user.vat = '';
        if (user.name === 'False') user.name = '';
        if (user.x_title_postfix === 'False') user.x_title_postfix = '';
        if (user.x_qr_login === 'False') user.email = '';
        if (user.mobile === 'False') user.mobile = '';
        if (user.street === 'False') user.street = '';
        if (user.zip === 'False') user.zip = '';
        if (user.city === 'False') user.city = '';
        if (user.x_account_owner === 'False') user.x_account_owner = '';
        if (user.x_account_bic === 'False') user.x_account_bic='';
        if (user.x_account_iban === 'False') user.x_account_iban = '';
        if (firmenbuch_nr === '') user.x_firmenbuch_nr='';

        if (anrede !== user.x_anrede) data['Anrede'] = anrede;
        if (title !== user.title.split("'")[1]) data['Titel'] = title;
        if (firmenbuch_nr !== user.x_firmenbuch_nr) data['Firmenbuchnummer'] = firmenbuch_nr;
        if (vat !== user.vat) data['UID'] = vat;
        if (name !== user.name) data['Name'] = name;
        if (title_postfix !== user.x_title_postfix) data['Titel hinten'] = title_postfix;
        if (birthdate !== user.x_birthdate) data['Geburtsdatum'] = birthdate;
        if (email !== user.email) data['E-Mail'] = email;
        if (mobile !== user.mobile) data['Mobil'] = mobile;
        if (street !== user.street) data['Strasse'] = street;
        if (zip !== user.zip) data['PLZ'] = zip;
        if (city !== user.city) data['Ort'] = city;
        if (account_owner !== user.x_account_owner) data['Kontoinhaber'] = account_owner;
        if (account_bic !== user.x_account_bic) data['BIC'] = account_bic;
        if (account_iban !== user.x_account_iban) data['IBAN'] = account_iban;
        
        if (Object.keys(data).length > 0) {
            API.post_UserUpdate(data)
                .then(() => {
                    props.updated(true);
                    setIsLoading(false);
                })
                .catch(err => {
                    setIsLoading(false);
                    setErrorMsg(err.response.data.detail)
                })
        }
    }

    return (
        <Form onSubmit={e => submitHandler(e)} className="mt-5">
            {user?.company_type === "person"?
                <Row>
                    <p className="text-energo">Personliche Daten</p>
                    <Col md="6" xl="4">
                        <Form.Group>
                            <FloatingLabel label="Anrede">
                                <Form.Select 
                                    size="lg"
                                    defaultValue={anrede}
                                    onChange={e => setAnrede(e.target.value)}
                                >
                                    <option value="Leer"></option>
                                    <option value="Herr">Herr</option>
                                    <option value="Frau">Frau</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Form.Group>
                    </Col>
                    <Col xs="12" md="6" xl="3">
                        <Form.Group>
                            <FloatingLabel label="Titel">
                                <Form.Select
                                    size="lg"
                                    defaultValue={title}
                                    onChange={e => setTitle(e.target.value)}
                                >
                                    <option value=""></option>
                                    <option value="DDr.">DDr.</option>
                                    <option value="DI">DI</option>
                                    <option value="DI (FH)">DI (FH)</option>
                                    <option value="DI Dr.">DI Dr.</option>
                                    <option value="Dipl. Päd.">Dipl. Päd.</option>
                                    <option value="Dipl. WI (FH)">Dipl. WI (FH)</option>
                                    <option value="Dipl.-Ing.">Dipl.-Ing.</option>
                                    <option value="Dipl.-Ing. Dr.">Dipl.-Ing. Dr.</option>
                                    <option value="Dr.">Dr.</option>
                                    <option value="Ing.">Ing.</option>
                                    <option value="Ing. Mag.">Ing. Mag.</option>
                                    <option value="Mag.">Mag.</option>
                                    <option value="Mag. (FH)">Mag. (FH)</option>
                                    <option value="Mag. Dr.">Mag. Dr.</option>
                                    <option value="Prof.">Prof.</option>
                                    <option value="Univ.-Prof Dr.">Univ.-Prof Dr.</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Form.Group>
                    </Col>
                </Row>
                :
                <Row>
                    <p className="text-energo">Unternehmensdaten</p>
                    <Col md="6" xl="6">
                        <Form.Group>
                            <FloatingLabel label="Firmenbuchnummer">
                                <Form.Control type="text" value={firmenbuch_nr} onChange={e => setFirmenbuch_nr(e.target.value)} />
                            </FloatingLabel>
                        </Form.Group>
                    </Col>
                    <Col xs="12" md="6" xl="6">
                        <Form.Group>
                            <FloatingLabel label="UID">
                                <Form.Control type="text" value={vat} onChange={e => setVat(e.target.value)} />
                            </FloatingLabel>
                        </Form.Group>
                    </Col>
                </Row>
            }
            <Row className="mt-3">
                <Col xl="6">
                    <Form.Group>
                        <FloatingLabel label="Name">
                            <Form.Control type="text" value={name} onChange={e => setName(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                    <Col md="6" xl="4" hidden={user.company_type !== 'person'}>
                        <Form.Group>
                            <FloatingLabel label="Titel hinten">
                                <Form.Control type="text" value={title_postfix} onChange={e => setTitle_postfix(e.target.value)} />
                            </FloatingLabel>
                        </Form.Group>
                    </Col>
            </Row>
            {user?.company_type === "person"?
                <Row className="mt-3">
                    <Col xs="12" md="6" xl="4">
                        <Form.Group>
                            <FloatingLabel label="Geburtsdatum">
                                <Form.Control 
                                type="date" 
                                value={birthdate} max={new Date().toISOString().split('T')[0]} 
                                onChange={e => setBirthdate(e.target.value)}
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Col>
                </Row>
            :null}

            <Row className="mt-5">
                <p className="text-energo">Kontaktdaten</p>
                <Col md="12" xl="6">
                    <Form.Group>
                        <FloatingLabel label="E-Mail">
                            <Form.Control type="email" value={email} onChange={e => setEmail(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" xl="6">
                    <Form.Group>
                        <FloatingLabel label="Telefonnummer">
                            <Form.Control type="phone" value={mobile === 'False'? '':mobile}
                                onChange={e => setMobile(e.target.value)}
                            />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mt-5">
                <p className="text-energo">Adresse</p>
                <Col xl="8">
                    <Form.Group>
                        <FloatingLabel label="Straße">
                            <Form.Control type="text" value={street} onChange={e => setStreet(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" xl="4">
                    <Form.Group>
                        <FloatingLabel label="PLZ">
                            <Form.Control type="text" value={zip} onChange={e => setZip(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xl="8">
                    <Form.Group>
                        <FloatingLabel label="Ort">
                            <Form.Control type="text" value={city} onChange={e => setCity(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mt-5">
                <p className="text-energo">Bankdaten</p>
                <Col xl="8">
                    <Form.Group>
                        <FloatingLabel label="Kontoinhaber">
                            <Form.Control type="text" value={account_owner} onChange={e => setAccount_owner(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" xl="4">
                    <Form.Group>
                        <FloatingLabel label="BIC">
                            <Form.Control type="text" value={account_bic} onChange={e => setAccount_bic(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xl="8">
                    <Form.Group>
                        <FloatingLabel label="IBAN">
                            <Form.Control type="text" value={account_iban} onChange={e => setAccount_iban(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>
        
            <Row className="mt-5 align-items-center">
                <Col xl="12" className="text-end">
                    {isLoading?
                        <Spinner animation="border" className="text-energo" />
                    :
                        <>
                            <p className="text-danger">{errorMsg}</p>
                            <Button type="submit" className="btn-lg btn-energo">Absenden</Button>
                        </>
                    }
                </Col>
            </Row>
        </Form>
    )
}

export default ProfileForm;